import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import { Button } from '@repo/ui';
import { colorPalette } from '@repo/mui-config/color-palette';

interface AgreementSmsConfirmationCountdown {
  isEnabled: boolean;
  onCountdownClick: () => void;
}

const AGREEMENT_SMS_CONFIRMATION_SEND_CODE_AGAIN_SECONDS = 30;

export function AgreementSmsConfirmationCountdown({
  isEnabled,
  onCountdownClick,
}: AgreementSmsConfirmationCountdown) {
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState<number>(0);
  const disabledCountdown = !isEnabled || countdown !== 0;

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;

    if (countdown > 0) {
      interval = setInterval(() => {
        countdown > 0 && setCountdown((prevState) => prevState - 1);
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [countdown]);

  return (
    <Stack
      alignItems="center"
      direction={{ md: 'row', sm: 'column-reverse' }}
      justifyContent="end"
      sx={{ marginTop: '6px' }}
    >
      {countdown !== 0 && (
        <Typography variant="body2">
          ({t('loanProcess.loanSteps.sms.confirmation.on')} 00:
          {countdown < 10 && '0'}
          {countdown})
        </Typography>
      )}
      <Button
        data-testid="agreement-sms-confirmation-countdown-button"
        disabled={disabledCountdown}
        onClick={() => {
          if (!isEnabled) return;
          onCountdownClick();
          setCountdown(AGREEMENT_SMS_CONFIRMATION_SEND_CODE_AGAIN_SECONDS);
        }}
        sx={{
          textTransform: 'none',
          '&:hover': {
            background: 'none',
          },
          '&:active': {
            background: 'none',
          },
          '&:disabled': {
            backgroundColor: 'transparent ',
          },
          justifyContent: 'flex-end',
        }}
        type="button"
      >
        <Typography
          color={disabledCountdown ? colorPalette.ink.light : colorPalette.ink.main}
          variant="body2"
        >
          {t('loanProcess.loanSteps.sms.confirmation.sendSmsCodeAgain')}
        </Typography>
      </Button>
    </Stack>
  );
}
